'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _clone = require('./clone');

var _clone2 = _interopRequireDefault(_clone);

var _errors = require('../errors');

var BaseValidator = (function () {
  function BaseValidator() {
    _classCallCheck(this, BaseValidator);

    this._validations = [];
  }

  _createClass(BaseValidator, [{
    key: 'arityIsZero',
    value: function arityIsZero(args) {
      var _this = this;

      return this.addValidation(function () {
        return args.length === 0;
      }, function () {
        return _errors.messages.arityValidations.arityIsZero(_this.operatorName);
      });
    }
  }, {
    key: 'arityIsOne',
    value: function arityIsOne(args) {
      var _this2 = this;

      return this.addValidation(function () {
        return args.length === 1;
      }, function () {
        return _errors.messages.arityValidations.arityIsOne(_this2.operatorName);
      });
    }
  }, {
    key: 'arityIsTwo',
    value: function arityIsTwo(args) {
      var _this3 = this;

      return this.addValidation(function () {
        return args.length === 2;
      }, function () {
        return _errors.messages.arityValidations.arityIsTwo(_this3.operatorName);
      });
    }
  }, {
    key: 'arityIsThree',
    value: function arityIsThree(args) {
      var _this4 = this;

      return this.addValidation(function () {
        return args.length === 3;
      }, function () {
        return _errors.messages.arityValidations.arityIsThree(_this4.operatorName);
      });
    }
  }, {
    key: 'arityIsAtLeastTwo',
    value: function arityIsAtLeastTwo(args) {
      var _this5 = this;

      return this.addValidation(function () {
        return args.length >= 2;
      }, function () {
        return _errors.messages.arityValidations.arityIsAtLeastTwo(_this5.operatorName);
      });
    }
  }, {
    key: 'arityIsAtLeastOne',
    value: function arityIsAtLeastOne(args) {
      var _this6 = this;

      return this.addValidation(function () {
        return args.length >= 1;
      }, function () {
        return _errors.messages.arityValidations.arityIsAtLeastOne(_this6.operatorName);
      });
    }
  }, {
    key: 'addValidation',
    value: function addValidation(predicateFn, messageFn) {
      this._validations.push({
        predicateFn: predicateFn,
        messageFn: messageFn
      });
      return this;
    }
  }]);

  return BaseValidator;
})();

var AggregatingValidator = (function (_BaseValidator) {
  _inherits(AggregatingValidator, _BaseValidator);

  function AggregatingValidator(previousInvalidArguments) {
    _classCallCheck(this, AggregatingValidator);

    _get(Object.getPrototypeOf(AggregatingValidator.prototype), 'constructor', this).call(this);
    this._invalidArguments = (0, _clone2['default'])(previousInvalidArguments);
  }

  _createClass(AggregatingValidator, [{
    key: 'validateAndAggregate',
    value: function validateAndAggregate() {
      var _this7 = this;

      var valid = this._validations.every(function (_ref) {
        var predicateFn = _ref.predicateFn;
        var messageFn = _ref.messageFn;
        return _this7._appendIfInvalid(predicateFn(), messageFn());
      });
      return [this._invalidArguments, valid];
    }
  }, {
    key: '_appendIfInvalid',
    value: function _appendIfInvalid(valid, message) {
      if (!valid) {
        this._invalidArguments.push(message);
        return false;
      }
      return true;
    }
  }]);

  return AggregatingValidator;
})(BaseValidator);

exports.AggregatingValidator = AggregatingValidator;

var RejectingValidator = (function (_BaseValidator2) {
  _inherits(RejectingValidator, _BaseValidator2);

  function RejectingValidator() {
    _classCallCheck(this, RejectingValidator);

    _get(Object.getPrototypeOf(RejectingValidator.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(RejectingValidator, [{
    key: 'validateAndReject',
    value: function validateAndReject() {
      var _this8 = this;

      return Promise.resolve().then(function () {
        _this8._validations.forEach(function (_ref2) {
          var predicateFn = _ref2.predicateFn;
          var messageFn = _ref2.messageFn;

          if (!predicateFn()) {
            throw (0, _errors.validationError)(messageFn());
          }
        });
      });
    }
  }]);

  return RejectingValidator;
})(BaseValidator);

exports.RejectingValidator = RejectingValidator;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/utils/base-validator.js
// module id = 16
// module chunks = 0